module.exports = __webpack_public_path__ + "static/media/current_cycle_right.bf19ed14.svg";